import React, { useState } from "react";
import { getUserId, getUserName, setUserName } from "./utils/user";
import NameModal from "./components/NameModal";
import Navigation from "./components/Navigation";
import GalleryScreen from "./screens/GalleryScreen";
import ScheduleScreen from "./screens/ScheduleScreen";
import MenuScreen from "./screens/MenuScreen";
import BingoScreen from "./screens/BingoScreen";
import SeatingScreen from "./screens/SeatingScreen";
import BarScreen from "./screens/BarScreen";

export default function App() {
  const [tab, setTab] = useState("gallery");
  const [userName, setUserNameState] = useState(getUserName);
  const [adminMode, setAdminMode] = useState(false);
  const userId = getUserId();

  const handleNameSave = (name) => {
    setUserName(name);
    setUserNameState(name);
  };

  if (!userName) return <NameModal onSave={handleNameSave} />;

  return (
    <div className="app">
      <div className="app__deco app__deco--1" />
      <div className="app__deco app__deco--2" />

      <div className="app__content">
        {tab === "gallery"  && <GalleryScreen userId={userId} userName={userName} adminMode={adminMode} onAdminChange={setAdminMode} />}
        {tab === "schedule" && <ScheduleScreen />}
        {tab === "menu"     && <MenuScreen />}
        {tab === "bingo"    && <BingoScreen userId={userId} userName={userName} />}
        {tab === "seating"  && <SeatingScreen />}
        {tab === "bar"      && <BarScreen />}
      </div>

      <Navigation active={tab} onChange={setTab} />
    </div>
  );
}
